/**
 * Whether this credential field type stores a secret (password) value.
 * Those values are not trimmed so leading/trailing spaces are preserved if intended.
 */
export function isIndirectTaxCredentialSecretType(credentialType: string): boolean {
  const t = credentialType.toLowerCase();
  return t === 'securestring' || t === 'password';
}

/**
 * Trims leading/trailing whitespace for non-secret credential inputs
 * (e.g. portal URL, username, tax ID).
 */
export function trimIndirectTaxCredentialFieldValue(
  value: string,
  credentialType: string
): string {
  if (isIndirectTaxCredentialSecretType(credentialType)) {
    return value;
  }
  return value.trim();
}
